import { a as _extends, b as _objectWithoutProperties, c as _classCallCheck, d as _createClass, e as _possibleConstructorReturn, f as _getPrototypeOf, g as _inherits, h as _assertThisInitialized, i as _defineProperty, j as _asyncToGenerator } from './chunk-62fb3b11.js';
import React, { PureComponent, createElement } from 'react';
import PropTypes from 'prop-types';

var flags = {
  'ad': function ad() {
    return import(
    /* webpackChunkName: "flag-ad" */
    "./FlagAd.js");
  },
  'ae': function ae() {
    return import(
    /* webpackChunkName: "flag-ae" */
    "./FlagAe.js");
  },
  'af': function af() {
    return import(
    /* webpackChunkName: "flag-af" */
    "./FlagAf.js");
  },
  'ag': function ag() {
    return import(
    /* webpackChunkName: "flag-ag" */
    "./FlagAg.js");
  },
  'ai': function ai() {
    return import(
    /* webpackChunkName: "flag-ai" */
    "./FlagAi.js");
  },
  'al': function al() {
    return import(
    /* webpackChunkName: "flag-al" */
    "./FlagAl.js");
  },
  'am': function am() {
    return import(
    /* webpackChunkName: "flag-am" */
    "./FlagAm.js");
  },
  'an': function an() {
    return import(
    /* webpackChunkName: "flag-an" */
    "./FlagAn.js");
  },
  'ao': function ao() {
    return import(
    /* webpackChunkName: "flag-ao" */
    "./FlagAo.js");
  },
  'aq': function aq() {
    return import(
    /* webpackChunkName: "flag-aq" */
    "./FlagAq.js");
  },
  'ar': function ar() {
    return import(
    /* webpackChunkName: "flag-ar" */
    "./FlagAr.js");
  },
  'as': function as() {
    return import(
    /* webpackChunkName: "flag-as" */
    "./FlagAs.js");
  },
  'at': function at() {
    return import(
    /* webpackChunkName: "flag-at" */
    "./FlagAt.js");
  },
  'au': function au() {
    return import(
    /* webpackChunkName: "flag-au" */
    "./FlagAu.js");
  },
  'aw': function aw() {
    return import(
    /* webpackChunkName: "flag-aw" */
    "./FlagAw.js");
  },
  'ax': function ax() {
    return import(
    /* webpackChunkName: "flag-ax" */
    "./FlagAx.js");
  },
  'az': function az() {
    return import(
    /* webpackChunkName: "flag-az" */
    "./FlagAz.js");
  },
  'ba': function ba() {
    return import(
    /* webpackChunkName: "flag-ba" */
    "./FlagBa.js");
  },
  'bb': function bb() {
    return import(
    /* webpackChunkName: "flag-bb" */
    "./FlagBb.js");
  },
  'bd': function bd() {
    return import(
    /* webpackChunkName: "flag-bd" */
    "./FlagBd.js");
  },
  'be': function be() {
    return import(
    /* webpackChunkName: "flag-be" */
    "./FlagBe.js");
  },
  'bf': function bf() {
    return import(
    /* webpackChunkName: "flag-bf" */
    "./FlagBf.js");
  },
  'bg': function bg() {
    return import(
    /* webpackChunkName: "flag-bg" */
    "./FlagBg.js");
  },
  'bh': function bh() {
    return import(
    /* webpackChunkName: "flag-bh" */
    "./FlagBh.js");
  },
  'bi': function bi() {
    return import(
    /* webpackChunkName: "flag-bi" */
    "./FlagBi.js");
  },
  'bj': function bj() {
    return import(
    /* webpackChunkName: "flag-bj" */
    "./FlagBj.js");
  },
  'bl': function bl() {
    return import(
    /* webpackChunkName: "flag-bl" */
    "./FlagBl.js");
  },
  'bm': function bm() {
    return import(
    /* webpackChunkName: "flag-bm" */
    "./FlagBm.js");
  },
  'bn': function bn() {
    return import(
    /* webpackChunkName: "flag-bn" */
    "./FlagBn.js");
  },
  'bo': function bo() {
    return import(
    /* webpackChunkName: "flag-bo" */
    "./FlagBo.js");
  },
  'bq': function bq() {
    return import(
    /* webpackChunkName: "flag-bq" */
    "./FlagBq.js");
  },
  'br': function br() {
    return import(
    /* webpackChunkName: "flag-br" */
    "./FlagBr.js");
  },
  'bs': function bs() {
    return import(
    /* webpackChunkName: "flag-bs" */
    "./FlagBs.js");
  },
  'bt': function bt() {
    return import(
    /* webpackChunkName: "flag-bt" */
    "./FlagBt.js");
  },
  'bv': function bv() {
    return import(
    /* webpackChunkName: "flag-bv" */
    "./FlagBv.js");
  },
  'bw': function bw() {
    return import(
    /* webpackChunkName: "flag-bw" */
    "./FlagBw.js");
  },
  'by': function by() {
    return import(
    /* webpackChunkName: "flag-by" */
    "./FlagBy.js");
  },
  'bz': function bz() {
    return import(
    /* webpackChunkName: "flag-bz" */
    "./FlagBz.js");
  },
  'ca': function ca() {
    return import(
    /* webpackChunkName: "flag-ca" */
    "./FlagCa.js");
  },
  'cc': function cc() {
    return import(
    /* webpackChunkName: "flag-cc" */
    "./FlagCc.js");
  },
  'cd': function cd() {
    return import(
    /* webpackChunkName: "flag-cd" */
    "./FlagCd.js");
  },
  'cf': function cf() {
    return import(
    /* webpackChunkName: "flag-cf" */
    "./FlagCf.js");
  },
  'cg': function cg() {
    return import(
    /* webpackChunkName: "flag-cg" */
    "./FlagCg.js");
  },
  'ch': function ch() {
    return import(
    /* webpackChunkName: "flag-ch" */
    "./FlagCh.js");
  },
  'ci': function ci() {
    return import(
    /* webpackChunkName: "flag-ci" */
    "./FlagCi.js");
  },
  'ck': function ck() {
    return import(
    /* webpackChunkName: "flag-ck" */
    "./FlagCk.js");
  },
  'cl': function cl() {
    return import(
    /* webpackChunkName: "flag-cl" */
    "./FlagCl.js");
  },
  'cm': function cm() {
    return import(
    /* webpackChunkName: "flag-cm" */
    "./FlagCm.js");
  },
  'cn': function cn() {
    return import(
    /* webpackChunkName: "flag-cn" */
    "./FlagCn.js");
  },
  'co': function co() {
    return import(
    /* webpackChunkName: "flag-co" */
    "./FlagCo.js");
  },
  'cr': function cr() {
    return import(
    /* webpackChunkName: "flag-cr" */
    "./FlagCr.js");
  },
  'cu': function cu() {
    return import(
    /* webpackChunkName: "flag-cu" */
    "./FlagCu.js");
  },
  'cv': function cv() {
    return import(
    /* webpackChunkName: "flag-cv" */
    "./FlagCv.js");
  },
  'cw': function cw() {
    return import(
    /* webpackChunkName: "flag-cw" */
    "./FlagCw.js");
  },
  'cx': function cx() {
    return import(
    /* webpackChunkName: "flag-cx" */
    "./FlagCx.js");
  },
  'cy': function cy() {
    return import(
    /* webpackChunkName: "flag-cy" */
    "./FlagCy.js");
  },
  'cz': function cz() {
    return import(
    /* webpackChunkName: "flag-cz" */
    "./FlagCz.js");
  },
  'de': function de() {
    return import(
    /* webpackChunkName: "flag-de" */
    "./FlagDe.js");
  },
  'dj': function dj() {
    return import(
    /* webpackChunkName: "flag-dj" */
    "./FlagDj.js");
  },
  'dk': function dk() {
    return import(
    /* webpackChunkName: "flag-dk" */
    "./FlagDk.js");
  },
  'dm': function dm() {
    return import(
    /* webpackChunkName: "flag-dm" */
    "./FlagDm.js");
  },
  'do': function _do() {
    return import(
    /* webpackChunkName: "flag-do" */
    "./FlagDo.js");
  },
  'dz': function dz() {
    return import(
    /* webpackChunkName: "flag-dz" */
    "./FlagDz.js");
  },
  'ec': function ec() {
    return import(
    /* webpackChunkName: "flag-ec" */
    "./FlagEc.js");
  },
  'ee': function ee() {
    return import(
    /* webpackChunkName: "flag-ee" */
    "./FlagEe.js");
  },
  'eg': function eg() {
    return import(
    /* webpackChunkName: "flag-eg" */
    "./FlagEg.js");
  },
  'eh': function eh() {
    return import(
    /* webpackChunkName: "flag-eh" */
    "./FlagEh.js");
  },
  'er': function er() {
    return import(
    /* webpackChunkName: "flag-er" */
    "./FlagEr.js");
  },
  'es': function es() {
    return import(
    /* webpackChunkName: "flag-es" */
    "./FlagEs.js");
  },
  'et': function et() {
    return import(
    /* webpackChunkName: "flag-et" */
    "./FlagEt.js");
  },
  'eu': function eu() {
    return import(
    /* webpackChunkName: "flag-eu" */
    "./FlagEu.js");
  },
  'fi': function fi() {
    return import(
    /* webpackChunkName: "flag-fi" */
    "./FlagFi.js");
  },
  'fj': function fj() {
    return import(
    /* webpackChunkName: "flag-fj" */
    "./FlagFj.js");
  },
  'fk': function fk() {
    return import(
    /* webpackChunkName: "flag-fk" */
    "./FlagFk.js");
  },
  'fm': function fm() {
    return import(
    /* webpackChunkName: "flag-fm" */
    "./FlagFm.js");
  },
  'fo': function fo() {
    return import(
    /* webpackChunkName: "flag-fo" */
    "./FlagFo.js");
  },
  'fr': function fr() {
    return import(
    /* webpackChunkName: "flag-fr" */
    "./FlagFr.js");
  },
  'ga': function ga() {
    return import(
    /* webpackChunkName: "flag-ga" */
    "./FlagGa.js");
  },
  'gb': function gb() {
    return import(
    /* webpackChunkName: "flag-gb" */
    "./FlagGb.js");
  },
  'gd': function gd() {
    return import(
    /* webpackChunkName: "flag-gd" */
    "./FlagGd.js");
  },
  'ge': function ge() {
    return import(
    /* webpackChunkName: "flag-ge" */
    "./FlagGe.js");
  },
  'gf': function gf() {
    return import(
    /* webpackChunkName: "flag-gf" */
    "./FlagGf.js");
  },
  'gg': function gg() {
    return import(
    /* webpackChunkName: "flag-gg" */
    "./FlagGg.js");
  },
  'gh': function gh() {
    return import(
    /* webpackChunkName: "flag-gh" */
    "./FlagGh.js");
  },
  'gi': function gi() {
    return import(
    /* webpackChunkName: "flag-gi" */
    "./FlagGi.js");
  },
  'gl': function gl() {
    return import(
    /* webpackChunkName: "flag-gl" */
    "./FlagGl.js");
  },
  'gm': function gm() {
    return import(
    /* webpackChunkName: "flag-gm" */
    "./FlagGm.js");
  },
  'gn': function gn() {
    return import(
    /* webpackChunkName: "flag-gn" */
    "./FlagGn.js");
  },
  'gp': function gp() {
    return import(
    /* webpackChunkName: "flag-gp" */
    "./FlagGp.js");
  },
  'gq': function gq() {
    return import(
    /* webpackChunkName: "flag-gq" */
    "./FlagGq.js");
  },
  'gr': function gr() {
    return import(
    /* webpackChunkName: "flag-gr" */
    "./FlagGr.js");
  },
  'gs': function gs() {
    return import(
    /* webpackChunkName: "flag-gs" */
    "./FlagGs.js");
  },
  'gt': function gt() {
    return import(
    /* webpackChunkName: "flag-gt" */
    "./FlagGt.js");
  },
  'gu': function gu() {
    return import(
    /* webpackChunkName: "flag-gu" */
    "./FlagGu.js");
  },
  'gw': function gw() {
    return import(
    /* webpackChunkName: "flag-gw" */
    "./FlagGw.js");
  },
  'gy': function gy() {
    return import(
    /* webpackChunkName: "flag-gy" */
    "./FlagGy.js");
  },
  'hk': function hk() {
    return import(
    /* webpackChunkName: "flag-hk" */
    "./FlagHk.js");
  },
  'hm': function hm() {
    return import(
    /* webpackChunkName: "flag-hm" */
    "./FlagHm.js");
  },
  'hn': function hn() {
    return import(
    /* webpackChunkName: "flag-hn" */
    "./FlagHn.js");
  },
  'hr': function hr() {
    return import(
    /* webpackChunkName: "flag-hr" */
    "./FlagHr.js");
  },
  'ht': function ht() {
    return import(
    /* webpackChunkName: "flag-ht" */
    "./FlagHt.js");
  },
  'hu': function hu() {
    return import(
    /* webpackChunkName: "flag-hu" */
    "./FlagHu.js");
  },
  'id': function id() {
    return import(
    /* webpackChunkName: "flag-id" */
    "./FlagId.js");
  },
  'ie': function ie() {
    return import(
    /* webpackChunkName: "flag-ie" */
    "./FlagIe.js");
  },
  'il': function il() {
    return import(
    /* webpackChunkName: "flag-il" */
    "./FlagIl.js");
  },
  'im': function im() {
    return import(
    /* webpackChunkName: "flag-im" */
    "./FlagIm.js");
  },
  'in': function _in() {
    return import(
    /* webpackChunkName: "flag-in" */
    "./FlagIn.js");
  },
  'io': function io() {
    return import(
    /* webpackChunkName: "flag-io" */
    "./FlagIo.js");
  },
  'iq': function iq() {
    return import(
    /* webpackChunkName: "flag-iq" */
    "./FlagIq.js");
  },
  'ir': function ir() {
    return import(
    /* webpackChunkName: "flag-ir" */
    "./FlagIr.js");
  },
  'is': function is() {
    return import(
    /* webpackChunkName: "flag-is" */
    "./FlagIs.js");
  },
  'it': function it() {
    return import(
    /* webpackChunkName: "flag-it" */
    "./FlagIt.js");
  },
  'je': function je() {
    return import(
    /* webpackChunkName: "flag-je" */
    "./FlagJe.js");
  },
  'jm': function jm() {
    return import(
    /* webpackChunkName: "flag-jm" */
    "./FlagJm.js");
  },
  'jo': function jo() {
    return import(
    /* webpackChunkName: "flag-jo" */
    "./FlagJo.js");
  },
  'jp': function jp() {
    return import(
    /* webpackChunkName: "flag-jp" */
    "./FlagJp.js");
  },
  'ke': function ke() {
    return import(
    /* webpackChunkName: "flag-ke" */
    "./FlagKe.js");
  },
  'kg': function kg() {
    return import(
    /* webpackChunkName: "flag-kg" */
    "./FlagKg.js");
  },
  'kh': function kh() {
    return import(
    /* webpackChunkName: "flag-kh" */
    "./FlagKh.js");
  },
  'ki': function ki() {
    return import(
    /* webpackChunkName: "flag-ki" */
    "./FlagKi.js");
  },
  'km': function km() {
    return import(
    /* webpackChunkName: "flag-km" */
    "./FlagKm.js");
  },
  'kn': function kn() {
    return import(
    /* webpackChunkName: "flag-kn" */
    "./FlagKn.js");
  },
  'kp': function kp() {
    return import(
    /* webpackChunkName: "flag-kp" */
    "./FlagKp.js");
  },
  'kr': function kr() {
    return import(
    /* webpackChunkName: "flag-kr" */
    "./FlagKr.js");
  },
  'kw': function kw() {
    return import(
    /* webpackChunkName: "flag-kw" */
    "./FlagKw.js");
  },
  'ky': function ky() {
    return import(
    /* webpackChunkName: "flag-ky" */
    "./FlagKy.js");
  },
  'kz': function kz() {
    return import(
    /* webpackChunkName: "flag-kz" */
    "./FlagKz.js");
  },
  'la': function la() {
    return import(
    /* webpackChunkName: "flag-la" */
    "./FlagLa.js");
  },
  'lb': function lb() {
    return import(
    /* webpackChunkName: "flag-lb" */
    "./FlagLb.js");
  },
  'lc': function lc() {
    return import(
    /* webpackChunkName: "flag-lc" */
    "./FlagLc.js");
  },
  'li': function li() {
    return import(
    /* webpackChunkName: "flag-li" */
    "./FlagLi.js");
  },
  'lk': function lk() {
    return import(
    /* webpackChunkName: "flag-lk" */
    "./FlagLk.js");
  },
  'lr': function lr() {
    return import(
    /* webpackChunkName: "flag-lr" */
    "./FlagLr.js");
  },
  'ls': function ls() {
    return import(
    /* webpackChunkName: "flag-ls" */
    "./FlagLs.js");
  },
  'lt': function lt() {
    return import(
    /* webpackChunkName: "flag-lt" */
    "./FlagLt.js");
  },
  'lu': function lu() {
    return import(
    /* webpackChunkName: "flag-lu" */
    "./FlagLu.js");
  },
  'lv': function lv() {
    return import(
    /* webpackChunkName: "flag-lv" */
    "./FlagLv.js");
  },
  'ly': function ly() {
    return import(
    /* webpackChunkName: "flag-ly" */
    "./FlagLy.js");
  },
  'ma': function ma() {
    return import(
    /* webpackChunkName: "flag-ma" */
    "./FlagMa.js");
  },
  'mc': function mc() {
    return import(
    /* webpackChunkName: "flag-mc" */
    "./FlagMc.js");
  },
  'md': function md() {
    return import(
    /* webpackChunkName: "flag-md" */
    "./FlagMd.js");
  },
  'me': function me() {
    return import(
    /* webpackChunkName: "flag-me" */
    "./FlagMe.js");
  },
  'mf': function mf() {
    return import(
    /* webpackChunkName: "flag-mf" */
    "./FlagMf.js");
  },
  'mg': function mg() {
    return import(
    /* webpackChunkName: "flag-mg" */
    "./FlagMg.js");
  },
  'mh': function mh() {
    return import(
    /* webpackChunkName: "flag-mh" */
    "./FlagMh.js");
  },
  'mk': function mk() {
    return import(
    /* webpackChunkName: "flag-mk" */
    "./FlagMk.js");
  },
  'ml': function ml() {
    return import(
    /* webpackChunkName: "flag-ml" */
    "./FlagMl.js");
  },
  'mm': function mm() {
    return import(
    /* webpackChunkName: "flag-mm" */
    "./FlagMm.js");
  },
  'mn': function mn() {
    return import(
    /* webpackChunkName: "flag-mn" */
    "./FlagMn.js");
  },
  'mo': function mo() {
    return import(
    /* webpackChunkName: "flag-mo" */
    "./FlagMo.js");
  },
  'mp': function mp() {
    return import(
    /* webpackChunkName: "flag-mp" */
    "./FlagMp.js");
  },
  'mq': function mq() {
    return import(
    /* webpackChunkName: "flag-mq" */
    "./FlagMq.js");
  },
  'mr': function mr() {
    return import(
    /* webpackChunkName: "flag-mr" */
    "./FlagMr.js");
  },
  'ms': function ms() {
    return import(
    /* webpackChunkName: "flag-ms" */
    "./FlagMs.js");
  },
  'mt': function mt() {
    return import(
    /* webpackChunkName: "flag-mt" */
    "./FlagMt.js");
  },
  'mu': function mu() {
    return import(
    /* webpackChunkName: "flag-mu" */
    "./FlagMu.js");
  },
  'mv': function mv() {
    return import(
    /* webpackChunkName: "flag-mv" */
    "./FlagMv.js");
  },
  'mw': function mw() {
    return import(
    /* webpackChunkName: "flag-mw" */
    "./FlagMw.js");
  },
  'mx': function mx() {
    return import(
    /* webpackChunkName: "flag-mx" */
    "./FlagMx.js");
  },
  'my': function my() {
    return import(
    /* webpackChunkName: "flag-my" */
    "./FlagMy.js");
  },
  'mz': function mz() {
    return import(
    /* webpackChunkName: "flag-mz" */
    "./FlagMz.js");
  },
  'na': function na() {
    return import(
    /* webpackChunkName: "flag-na" */
    "./FlagNa.js");
  },
  'nc': function nc() {
    return import(
    /* webpackChunkName: "flag-nc" */
    "./FlagNc.js");
  },
  'ne': function ne() {
    return import(
    /* webpackChunkName: "flag-ne" */
    "./FlagNe.js");
  },
  'nf': function nf() {
    return import(
    /* webpackChunkName: "flag-nf" */
    "./FlagNf.js");
  },
  'ng': function ng() {
    return import(
    /* webpackChunkName: "flag-ng" */
    "./FlagNg.js");
  },
  'ni': function ni() {
    return import(
    /* webpackChunkName: "flag-ni" */
    "./FlagNi.js");
  },
  'nl': function nl() {
    return import(
    /* webpackChunkName: "flag-nl" */
    "./FlagNl.js");
  },
  'no': function no() {
    return import(
    /* webpackChunkName: "flag-no" */
    "./FlagNo.js");
  },
  'np': function np() {
    return import(
    /* webpackChunkName: "flag-np" */
    "./FlagNp.js");
  },
  'nr': function nr() {
    return import(
    /* webpackChunkName: "flag-nr" */
    "./FlagNr.js");
  },
  'nu': function nu() {
    return import(
    /* webpackChunkName: "flag-nu" */
    "./FlagNu.js");
  },
  'nz': function nz() {
    return import(
    /* webpackChunkName: "flag-nz" */
    "./FlagNz.js");
  },
  'om': function om() {
    return import(
    /* webpackChunkName: "flag-om" */
    "./FlagOm.js");
  },
  'pa': function pa() {
    return import(
    /* webpackChunkName: "flag-pa" */
    "./FlagPa.js");
  },
  'pe': function pe() {
    return import(
    /* webpackChunkName: "flag-pe" */
    "./FlagPe.js");
  },
  'pf': function pf() {
    return import(
    /* webpackChunkName: "flag-pf" */
    "./FlagPf.js");
  },
  'pg': function pg() {
    return import(
    /* webpackChunkName: "flag-pg" */
    "./FlagPg.js");
  },
  'ph': function ph() {
    return import(
    /* webpackChunkName: "flag-ph" */
    "./FlagPh.js");
  },
  'pk': function pk() {
    return import(
    /* webpackChunkName: "flag-pk" */
    "./FlagPk.js");
  },
  'pl': function pl() {
    return import(
    /* webpackChunkName: "flag-pl" */
    "./FlagPl.js");
  },
  'pm': function pm() {
    return import(
    /* webpackChunkName: "flag-pm" */
    "./FlagPm.js");
  },
  'pn': function pn() {
    return import(
    /* webpackChunkName: "flag-pn" */
    "./FlagPn.js");
  },
  'pr': function pr() {
    return import(
    /* webpackChunkName: "flag-pr" */
    "./FlagPr.js");
  },
  'ps': function ps() {
    return import(
    /* webpackChunkName: "flag-ps" */
    "./FlagPs.js");
  },
  'pt': function pt() {
    return import(
    /* webpackChunkName: "flag-pt" */
    "./FlagPt.js");
  },
  'pw': function pw() {
    return import(
    /* webpackChunkName: "flag-pw" */
    "./FlagPw.js");
  },
  'py': function py() {
    return import(
    /* webpackChunkName: "flag-py" */
    "./FlagPy.js");
  },
  'qa': function qa() {
    return import(
    /* webpackChunkName: "flag-qa" */
    "./FlagQa.js");
  },
  're': function re() {
    return import(
    /* webpackChunkName: "flag-re" */
    "./FlagRe.js");
  },
  'ro': function ro() {
    return import(
    /* webpackChunkName: "flag-ro" */
    "./FlagRo.js");
  },
  'rs': function rs() {
    return import(
    /* webpackChunkName: "flag-rs" */
    "./FlagRs.js");
  },
  'ru': function ru() {
    return import(
    /* webpackChunkName: "flag-ru" */
    "./FlagRu.js");
  },
  'rw': function rw() {
    return import(
    /* webpackChunkName: "flag-rw" */
    "./FlagRw.js");
  },
  'sa': function sa() {
    return import(
    /* webpackChunkName: "flag-sa" */
    "./FlagSa.js");
  },
  'sb': function sb() {
    return import(
    /* webpackChunkName: "flag-sb" */
    "./FlagSb.js");
  },
  'sc': function sc() {
    return import(
    /* webpackChunkName: "flag-sc" */
    "./FlagSc.js");
  },
  'sd': function sd() {
    return import(
    /* webpackChunkName: "flag-sd" */
    "./FlagSd.js");
  },
  'se': function se() {
    return import(
    /* webpackChunkName: "flag-se" */
    "./FlagSe.js");
  },
  'sg': function sg() {
    return import(
    /* webpackChunkName: "flag-sg" */
    "./FlagSg.js");
  },
  'sh': function sh() {
    return import(
    /* webpackChunkName: "flag-sh" */
    "./FlagSh.js");
  },
  'si': function si() {
    return import(
    /* webpackChunkName: "flag-si" */
    "./FlagSi.js");
  },
  'sj': function sj() {
    return import(
    /* webpackChunkName: "flag-sj" */
    "./FlagSj.js");
  },
  'sk': function sk() {
    return import(
    /* webpackChunkName: "flag-sk" */
    "./FlagSk.js");
  },
  'sl': function sl() {
    return import(
    /* webpackChunkName: "flag-sl" */
    "./FlagSl.js");
  },
  'sm': function sm() {
    return import(
    /* webpackChunkName: "flag-sm" */
    "./FlagSm.js");
  },
  'sn': function sn() {
    return import(
    /* webpackChunkName: "flag-sn" */
    "./FlagSn.js");
  },
  'so': function so() {
    return import(
    /* webpackChunkName: "flag-so" */
    "./FlagSo.js");
  },
  'sr': function sr() {
    return import(
    /* webpackChunkName: "flag-sr" */
    "./FlagSr.js");
  },
  'ss': function ss() {
    return import(
    /* webpackChunkName: "flag-ss" */
    "./FlagSs.js");
  },
  'st': function st() {
    return import(
    /* webpackChunkName: "flag-st" */
    "./FlagSt.js");
  },
  'sv': function sv() {
    return import(
    /* webpackChunkName: "flag-sv" */
    "./FlagSv.js");
  },
  'sx': function sx() {
    return import(
    /* webpackChunkName: "flag-sx" */
    "./FlagSx.js");
  },
  'sy': function sy() {
    return import(
    /* webpackChunkName: "flag-sy" */
    "./FlagSy.js");
  },
  'sz': function sz() {
    return import(
    /* webpackChunkName: "flag-sz" */
    "./FlagSz.js");
  },
  'tc': function tc() {
    return import(
    /* webpackChunkName: "flag-tc" */
    "./FlagTc.js");
  },
  'td': function td() {
    return import(
    /* webpackChunkName: "flag-td" */
    "./FlagTd.js");
  },
  'tf': function tf() {
    return import(
    /* webpackChunkName: "flag-tf" */
    "./FlagTf.js");
  },
  'tg': function tg() {
    return import(
    /* webpackChunkName: "flag-tg" */
    "./FlagTg.js");
  },
  'th': function th() {
    return import(
    /* webpackChunkName: "flag-th" */
    "./FlagTh.js");
  },
  'tj': function tj() {
    return import(
    /* webpackChunkName: "flag-tj" */
    "./FlagTj.js");
  },
  'tk': function tk() {
    return import(
    /* webpackChunkName: "flag-tk" */
    "./FlagTk.js");
  },
  'tl': function tl() {
    return import(
    /* webpackChunkName: "flag-tl" */
    "./FlagTl.js");
  },
  'tm': function tm() {
    return import(
    /* webpackChunkName: "flag-tm" */
    "./FlagTm.js");
  },
  'tn': function tn() {
    return import(
    /* webpackChunkName: "flag-tn" */
    "./FlagTn.js");
  },
  'to': function to() {
    return import(
    /* webpackChunkName: "flag-to" */
    "./FlagTo.js");
  },
  'tr': function tr() {
    return import(
    /* webpackChunkName: "flag-tr" */
    "./FlagTr.js");
  },
  'tt': function tt() {
    return import(
    /* webpackChunkName: "flag-tt" */
    "./FlagTt.js");
  },
  'tv': function tv() {
    return import(
    /* webpackChunkName: "flag-tv" */
    "./FlagTv.js");
  },
  'tw': function tw() {
    return import(
    /* webpackChunkName: "flag-tw" */
    "./FlagTw.js");
  },
  'tz': function tz() {
    return import(
    /* webpackChunkName: "flag-tz" */
    "./FlagTz.js");
  },
  'ua': function ua() {
    return import(
    /* webpackChunkName: "flag-ua" */
    "./FlagUa.js");
  },
  'ug': function ug() {
    return import(
    /* webpackChunkName: "flag-ug" */
    "./FlagUg.js");
  },
  'um': function um() {
    return import(
    /* webpackChunkName: "flag-um" */
    "./FlagUm.js");
  },
  'us': function us() {
    return import(
    /* webpackChunkName: "flag-us" */
    "./FlagUs.js");
  },
  'uy': function uy() {
    return import(
    /* webpackChunkName: "flag-uy" */
    "./FlagUy.js");
  },
  'uz': function uz() {
    return import(
    /* webpackChunkName: "flag-uz" */
    "./FlagUz.js");
  },
  'va': function va() {
    return import(
    /* webpackChunkName: "flag-va" */
    "./FlagVa.js");
  },
  'vc': function vc() {
    return import(
    /* webpackChunkName: "flag-vc" */
    "./FlagVc.js");
  },
  've': function ve() {
    return import(
    /* webpackChunkName: "flag-ve" */
    "./FlagVe.js");
  },
  'vg': function vg() {
    return import(
    /* webpackChunkName: "flag-vg" */
    "./FlagVg.js");
  },
  'vi': function vi() {
    return import(
    /* webpackChunkName: "flag-vi" */
    "./FlagVi.js");
  },
  'vn': function vn() {
    return import(
    /* webpackChunkName: "flag-vn" */
    "./FlagVn.js");
  },
  'vu': function vu() {
    return import(
    /* webpackChunkName: "flag-vu" */
    "./FlagVu.js");
  },
  'wf': function wf() {
    return import(
    /* webpackChunkName: "flag-wf" */
    "./FlagWf.js");
  },
  'ws': function ws() {
    return import(
    /* webpackChunkName: "flag-ws" */
    "./FlagWs.js");
  },
  'xk': function xk() {
    return import(
    /* webpackChunkName: "flag-xk" */
    "./FlagXk.js");
  },
  'ye': function ye() {
    return import(
    /* webpackChunkName: "flag-ye" */
    "./FlagYe.js");
  },
  'yt': function yt() {
    return import(
    /* webpackChunkName: "flag-yt" */
    "./FlagYt.js");
  },
  'za': function za() {
    return import(
    /* webpackChunkName: "flag-za" */
    "./FlagZa.js");
  },
  'zm': function zm() {
    return import(
    /* webpackChunkName: "flag-zm" */
    "./FlagZm.js");
  },
  'zw': function zw() {
    return import(
    /* webpackChunkName: "flag-zw" */
    "./FlagZw.js");
  }
};

var fetchFlag =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(country) {
    var _ref2, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (flags[country]) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve(null));

          case 2:
            _context.next = 4;
            return flags[country]();

          case 4:
            _ref2 = _context.sent;
            data = _ref2.default;
            return _context.abrupt("return", data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchFlag(_x) {
    return _ref.apply(this, arguments);
  };
}(); // thanks to https://github.com/facebook/react/issues/5465#issuecomment-157888325


var makeCancelable = function makeCancelable(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : resolve(val);
    }, function (error) {
      return hasCanceled_ ? reject({
        isCanceled: true
      }) : reject(error);
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      hasCanceled_ = true;
    }
  };
};

var countries = function () {
  return Object.keys(flags);
}();

var Flags =
/*#__PURE__*/
function (_Component) {
  _inherits(Flags, _Component);

  function Flags() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Flags);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Flags)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelUpdate", function () {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      flag: null
    });

    return _this;
  }

  _createClass(Flags, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateFlag();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var country = this.props.country;

      if (country !== prevProps.country) {
        this.updateFlag();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelUpdate();
    }
  }, {
    key: "updateFlag",
    value: function updateFlag() {
      var _this2 = this;

      var country = this.props.country;

      var _makeCancelable = makeCancelable(fetchFlag(country)),
          promise = _makeCancelable.promise,
          cancel = _makeCancelable.cancel;

      promise.then(function (flag) {
        _this2.setState({
          flag: flag
        });
      });
      this.cancelUpdate = cancel;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          asSquare = _this$props.asSquare,
          country = _this$props.country,
          props = _objectWithoutProperties(_this$props, ["asSquare", "country"]);

      var flag = this.state.flag;
      if (!flag && !asSquare) return null;
      if (!asSquare) return createElement(flag, props);
      return React.createElement("svg", _extends({
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid"
      }, props), !flag ? null : createElement(flag));
    }
  }]);

  return Flags;
}(PureComponent);

_defineProperty(Flags, "defaultProps", {
  country: null,
  asSquare: false
});
Flags.propTypes = {
  country: PropTypes.string,
  asSquare: PropTypes.bool
};

export default Flags;
export { countries };
//# sourceMappingURL=index.js.map
